import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchUserPermissions } from '../services/permissionService.ts';

interface CheckOptions {
  menu?: string;
  allowGlobalFallback?: boolean;
}

export function useActionPermissionAlwaysRemote() {
  const location = useLocation();
  const [actions, setActions] = useState<string[]>([]);
  const [scopedActions, setScopedActions] = useState<string[]>([]);
  const [isPermissionReady, setIsPermissionReady] = useState(false);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    console.log('[权限] 当前 userId:', userId);
    if (!userId) {
      setActions([]);
      setScopedActions([]);
      setIsPermissionReady(true);
      console.log('[权限] userId 为空，actions=[]');
      return;
    }
    fetchUserPermissions(userId).then((result: { actionCodes?: string[]; scopedActionCodes?: string[] }) => {
      console.log('[权限] fetchUserPermissions result:', result);
      setActions(result.actionCodes || []);
      setScopedActions(result.scopedActionCodes || []);
      setIsPermissionReady(true);
      console.log('[权限] actions:', result.actionCodes, 'scopedActions:', result.scopedActionCodes);
    }).catch((err) => {
      setActions([]);
      setScopedActions([]);
      setIsPermissionReady(true);
      console.error('[权限] fetchUserPermissions error:', err);
    });
  // Re-run when route changes (including hash) so permissions refresh after login redirects
  }, [location.pathname, location.hash]);

  const can = (action: string, options?: CheckOptions) => {
    const has = actions.includes(action);
    console.log('[权限] can("' + action + '") =', has, 'actions:', actions);
    return has;
  };

  const canAny = (actionsToCheck: string[], options?: CheckOptions) => {
    const result = actionsToCheck.some((code) => can(code, options));
    console.log('[权限] canAny(', actionsToCheck, ') =', result);
    return result;
  };

  const canAll = (actionsToCheck: string[], options?: CheckOptions) => {
    return actionsToCheck.every((code) => can(code, options));
  };

  return {
    can,
    canAny,
    canAll,
    actions,
    scopedActions,
    isPermissionReady,
  };
}
